module.exports = __webpack_public_path__ + "static/media/research-1.5b5b4091.svg";